export const algoLimitSelectValAdjusted = (
  algosPerDay,
  algoLimitSelectVal = 0
) => {
  if (!algoLimitSelectVal) {
    return 0;
  }

  const adjusted = Math.abs(algosPerDay - algoLimitSelectVal);
  return adjusted;
};

export const findActivePlan = (plans) => {
  const getSubscribedPlan =
    plans.find(
      (plan) =>
        plan.subscription &&
        plan.subscription.status &&
        plan.subscription.status === 'active'
    ) || {};

  return getSubscribedPlan;
};

export const findIfAnyPlanActive = (plans) => {
  let toReturn = false;

  for (let index = 0; index < plans.length; index++) {
    if (
      plans[index].subscription &&
      plans[index].subscription.status &&
      plans[index].subscription.status === 'active'
    ) {
      toReturn = true;
      break;
    }
  }

  return toReturn;
};

export const findPlansFromEditPreview = (
  { lineItems = [], total = null },
  config = {}
) => {
  const { isEdit = false } = config;
  let currunt = lineItems.find((l) => l.lineItemType === 'UNUSED') || {};
  const next = lineItems.find((l) => l.lineItemType === 'FULL_TERM') || {};

  if (isEdit) {
    currunt = lineItems.find((l) => l.lineItemType === 'REMAINING') || {};
  }

  const isFullTerm = lineItems.find((l) => l.lineItemType === 'FULL_TERM')
    ? true
    : false;

  const isFullTermOnly = lineItems && lineItems.length === 1 && isFullTerm;

  return {
    currunt,
    next,
    total,
    isFullTermOnly,
  };
};

export const findIfAnyPlanUpcoming = (plans) => {
  let toReturn = false;

  for (let index = 0; index < plans.length; index++) {
    if (
      plans[index].upcomingSubscription &&
      plans[index].upcomingSubscription.status &&
      plans[index].upcomingSubscription.status === 'active'
    ) {
      toReturn = true;
      break;
    }
  }

  return toReturn;
};
